require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.is-iterable');



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/fn/is-iterable.js
 ** module id = 2464
 ** module chunks = 0
 **/